var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, } from "react";
import { navigate } from "@reach/router";
import { InputGroup, InputLabel, InputText, useLoaderButton, useNotificationsCtx, TNotificationType, } from "@gw/component-library";
import { useBNIdentity } from "@gw/bn-identity";
var ChangePwd = function (_a) {
    var codeParam = _a.codeParam;
    var resetPwdWithCode = useBNIdentity().resetPwdWithCode;
    var _b = useState(""), email = _b[0], setEmail = _b[1];
    var _c = useState(""), pwd = _c[0], setPwd = _c[1];
    var _d = useState(""), pwdRepeat = _d[0], setPwdRepeat = _d[1];
    var _e = useState({}), errors = _e[0], setErrors = _e[1];
    var addNotification = useNotificationsCtx().addNotification;
    var _f = useLoaderButton({}), LoaderButton = _f.LoaderButton, enableButton = _f.enableButton, disableButton = _f.disableButton, setLoadingButton = _f.setLoadingButton;
    var canProceed = email !== "" && pwd !== "" && pwdRepeat !== "";
    var errorMessages = {
        reset: "Your reset token has been expired, please request again.",
        code: "Invalid code received",
        email: "Please review the errors below.",
        password: "Please review the errors below.",
    };
    useEffect(function () {
        if (!canProceed) {
            disableButton();
        }
        else {
            enableButton();
        }
    }, [email, pwd, pwdRepeat]);
    var handleSubmit = function (ev) {
        ev.preventDefault();
        setLoadingButton();
        resetPwdWithCode(email, codeParam, pwd, pwdRepeat)
            .then(function () {
            addNotification("Your password has been updated! Redirecting in 5 seconds...", TNotificationType.success);
            window.setTimeout(function () {
                navigate("/");
            }, 5000);
        })
            .catch(function (error) {
            var email = error.email, password = error.password;
            setErrors(Object.assign(__assign({}, errors), { email: email, password: password }));
            var key = Object.keys(error).find(function (key) { return errorMessages[key]; });
            addNotification(key
                ? errorMessages[key]
                : "We could not find a user with that email.", TNotificationType.error);
            enableButton();
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { className: "auth-form", onSubmit: handleSubmit },
            React.createElement(InputGroup, null,
                React.createElement(InputLabel, { htmlFor: "email" }, "Email:"),
                React.createElement(InputText, { value: email, name: "email", placeholder: "user@domain.com", type: "email", onChange: function (ev) {
                        setEmail(ev.target.value);
                    } }),
                errors.email && React.createElement("span", { className: "error-msg" }, errors.email)),
            React.createElement(InputGroup, null,
                React.createElement(InputLabel, { htmlFor: "pwd" }, "Password:"),
                React.createElement(InputText, { value: pwd, name: "pwd", placeholder: "Password", type: "password", onChange: function (ev) {
                        setPwd(ev.target.value);
                    } }),
                errors.password && (React.createElement("span", { className: "error-msg" }, errors.password))),
            React.createElement(InputGroup, null,
                React.createElement(InputLabel, { htmlFor: "pwdRep" }, "Re-Enter Password:"),
                React.createElement(InputText, { value: pwdRepeat, name: "pwdRepeat", placeholder: "Enter your password again", type: "password", onChange: function (ev) {
                        setPwdRepeat(ev.target.value);
                    } })),
            React.createElement("div", { className: "actions" },
                React.createElement(LoaderButton, { onClick: function (ev) { return handleSubmit(ev); } },
                    React.createElement(React.Fragment, null, "Submit"))))));
};
export default ChangePwd;
//# sourceMappingURL=ChangePwd.js.map